import { render } from "./CreateCategories.vue?vue&type=template&id=deab1d2e&scoped=true"
import script from "./CreateCategories.vue?vue&type=script&lang=js"
export * from "./CreateCategories.vue?vue&type=script&lang=js"

import "./CreateCategories.vue?vue&type=style&index=0&id=deab1d2e&lang=css"
import "./CreateCategories.vue?vue&type=style&index=1&id=deab1d2e&scoped=true&lang=css"
import "./CreateCategories.vue?vue&type=style&index=2&id=deab1d2e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deab1d2e"]])

export default __exports__